export default "__VITE_ASSET__785bac20__"